"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendTypingIndicatorOnSetSendBoxSaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _setSendBox = require("../actions/setSendBox");

var _setSendTypingIndicator = require("../actions/setSendTypingIndicator");

var _postActivity = require("../actions/postActivity");

var _emitTypingIndicator = _interopRequireDefault(require("../actions/emitTypingIndicator"));

var _sendTypingIndicator = _interopRequireDefault(require("../selectors/sendTypingIndicator"));

var _sleep = _interopRequireDefault(require("../utils/sleep"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(sendTypingIndicatorOnSetSendBox),
    _marked2 = /*#__PURE__*/_regeneratorRuntime2.mark(sendTypingIndicatorOnSetSendBoxSaga);

var SEND_INTERVAL = 3000;

function takeSendTypingIndicator(value) {
  return (0, _effects.take)(function (_ref) {
    var payload = _ref.payload,
        type = _ref.type;
    return type === _setSendTypingIndicator.SET_SEND_TYPING_INDICATOR && !payload.sendTypingIndicator === !value;
  });
}

function sendTypingIndicatorOnSetSendBox() {
  var sendTypingIndicator, _loop;

  return _regenerator["default"].wrap(function sendTypingIndicatorOnSetSendBox$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(_sendTypingIndicator["default"]);

        case 2:
          sendTypingIndicator = _context3.sent;

          if (sendTypingIndicator) {
            _context3.next = 6;
            break;
          }

          _context3.next = 6;
          return takeSendTypingIndicator(true);

        case 6:
          _loop = /*#__PURE__*/_regenerator["default"].mark(function _loop() {
            var lastSend, task;
            return _regenerator["default"].wrap(function _loop$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    lastSend = -Infinity;
                    _context2.next = 3;
                    return (0, _effects.takeLatest)(function (_ref2) {
                      var payload = _ref2.payload,
                          type = _ref2.type;
                      return type === _setSendBox.SET_SEND_BOX && payload.text || // Stop sending pending typing indicator if the user has posted anything.
                      // We send typing indicator in a debounce way (t = 0, t = 3000, t = 6000).
                      // When the user type, and then post the activity at t = 1500, we still have a pending typing indicator at t = 3000.
                      // This code is to cancel the typing indicator at t = 3000.
                      type === _postActivity.POST_ACTIVITY && payload.activity.type !== 'typing';
                    }, /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref3) {
                      var payload, type, interval;
                      return _regenerator["default"].wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              payload = _ref3.payload, type = _ref3.type;

                              if (!(type === _setSendBox.SET_SEND_BOX)) {
                                _context.next = 11;
                                break;
                              }

                              interval = SEND_INTERVAL - Date.now() + lastSend;

                              if (!(interval > 0)) {
                                _context.next = 6;
                                break;
                              }

                              _context.next = 6;
                              return (0, _effects.call)(_sleep["default"], interval);

                            case 6:
                              _context.next = 8;
                              return (0, _effects.put)((0, _emitTypingIndicator["default"])());

                            case 8:
                              lastSend = Date.now();
                              _context.next = 12;
                              break;

                            case 11:
                              if (payload.activity.type === 'message') {
                                lastSend = -Infinity;
                              }

                            case 12:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                  case 3:
                    task = _context2.sent;
                    _context2.next = 6;
                    return takeSendTypingIndicator(false);

                  case 6:
                    _context2.next = 8;
                    return (0, _effects.cancel)(task);

                  case 8:
                    _context2.next = 10;
                    return takeSendTypingIndicator(true);

                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _loop);
          });

        case 7:
          return _context3.delegateYield(_loop(), "t0", 8);

        case 8:
          _context3.next = 7;
          break;

        case 10:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked);
}

function sendTypingIndicatorOnSetSendBoxSaga() {
  return _regenerator["default"].wrap(function sendTypingIndicatorOnSetSendBoxSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _whileConnected["default"])(sendTypingIndicatorOnSetSendBox);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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